// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1YFPa","info":"PatientInfo_info__1nU7l"};